import { Err, Ok } from "@pacote/result"
import useSWR from "swr"
import useSWRMutation from "swr/mutation"
import { z } from "zod"
import { BaseApiErrorResponse, baseApiResponseSchema } from "./api-config"
import { withAuthClientFetcher } from "./base-fetchers"

const infoLoginResponseSchema = baseApiResponseSchema.extend({
  infoContoResults: z
    .array(
      z.object({
        key: z.string(),
        value: z.string().optional(),
      }),
    )
    .optional(),
})

export type InfoLoginResponse = z.infer<typeof infoLoginResponseSchema>

/* -------------------------------------------------------------------------------------------------
 * config
 * -----------------------------------------------------------------------------------------------*/
const infoLoginServiceEndpoint = "/platform-service/v1/sso/portal/infoLogin"

/* -------------------------------------------------------------------------------------------------
 * fetcher
 * -----------------------------------------------------------------------------------------------*/
const infoLoginFetcher = async (key: string) => {
  try {
    return await withAuthClientFetcher<InfoLoginResponse, BaseApiErrorResponse>(
      {
        url: key,
        successSchemaValidator: infoLoginResponseSchema,
        throwOnValidationError: true,
      },
    )
  } catch (error) {
    console.error("InfoLogin service error: ", error)
    return Err({})
  }
}

export function useInfoLoginMutation() {
  return useSWRMutation(infoLoginServiceEndpoint, infoLoginFetcher, {
    populateCache: true,
  })
}

export function useInfoLoginData() {
  return useSWR<Ok<InfoLoginResponse> | undefined>(infoLoginServiceEndpoint)
    .data?.value
}
